<template>
  <div>
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">
        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu id="ddl-page-limit">
              <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                <span>150</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                <span>Show All</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <!-- <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery"
          placeholder="Search..."/>-->
          <vs-button id="btn-add-device" class="mb-4 md:mb-0 mr-4" @click="add" icon="add">Add Device</vs-button>
          <vs-button id="btn-bulk-registration" class="mb-4 md:mb-0 mr-4" :to="'/device/bulk'">Bulk Registration</vs-button>
          <vs-button id="btn-export-csv" class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dataTrx"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="limit"
        :suppressPaginationPanel="true"
        :enableCellTextSelection="true"
      ></ag-grid-vue>
      <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import AxiosCall from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionTableAgGridComponent from "@/components/cell-render-component/ActionTableEditDeleteAgGridComponent";

export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        // filterParams: {
        //   applyButton: true,
        //   newRowsAction: 'keep'
        // },
      },
      columnDefs: [
        {
          headerName: "Serial Number",
          field: "serial_number",
          width: 500,
          filter: true
          /* checkboxSelection: true,
                         headerCheckboxSelectionFilteredOnly: true,
                         headerCheckboxSelection: true,*/
        },
        {
          headerName: "Device Type",
          field: "device_type.name",
          filter: true,
          width: 350
        },
        {
          headerName: "Actions",
          field: "id",
          filter: false,
          sortable: false,
          width: 250,
          cellRendererFramework: ActionTableAgGridComponent
        }
      ],
      dataTrx: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      totalData: 1,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("Channel", null);
      } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
    }
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      }
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type:"default",
      })
    },
    add() {
      this.$router.push({ path: "/device/add" });
    },
    deleteRecord(data) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: "Are you sure deleted this record ?",
        accept: () => {
          this.openLoading();
          AxiosCall.Delete(url.svd.device.delete + "/" + data)
                  .then(resp => {
                    if (resp.data === 1) {
                      this.fetchData(this.page, this.limit);
                      this.$vs.notify({
                        title: "Success",
                        text: "You successfully deleted!",
                        iconPack: "feather",
                        icon: "icon-check-square",
                        color: "success",
                        position: "top-right"
                      });
                    }
                    this.$vs.loading.close();
                  })
                  .catch(e => {
                    this.$vs.loading.close();
                    console.log(e);
                    this.$vs.notify({
                      title: "Failed",
                      text: "Network failed!",
                      iconPack: "feather",
                      icon: "icon-alert-circle",
                      color: "danger",
                      position: "top-right"
                    });
                  });
        }
      });
    },
    // onFilterModified(event){
      // console.log("modified", JSON.stringify(event.api.getFilterModel()))
      // console.log(Object.keys(event.api.getFilterModel()))
      // this.dataTrx = []
    // },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetchData(page, limit) {
      this.openLoading()
      // if (this.dataCount != 0) {
      //   let totalPages = Math.ceil(this.dataCount / limit);
      // }

      Axios.Get(
        url.svd.device.list + "?page=" + page + "&limit=" + limit
      )
        .then(resp => {
          this.$vs.loading.close()
          this.dataTrx = [];
          if (resp.data.data.length != 0) {
            this.totalData = parseInt(resp.data.total)
            let no = ((page - 1) * limit) + 1;
            for (let data of resp.data.data) {
              data.no = no;
              this.dataTrx.push(data);
              no++;
            }

            this.dataCount = resp.data.total;
            this.page = page;
            if (limit >= this.dataCount) {
              this.limit = this.dataTrx.length;
            } else {
              this.limit = limit;
            }

            this.gridApi.paginationSetPageSize(this.limit);
            this.totalPage = resp.data.lastPage;
          }
        })
        .catch(e => {
          this.$vs.loading.close()
          console.log(e);
        });
    },
    editRecord(value) {
      this.$store.commit("UPDATE_CURRENT_DEVICE_DATA", value)
      this.$router.push({
        name: "DeviceEdit",
        params: {
          id: value.id,
        }
      });
    },
    configureRecord(value) {
      this.$router.push({
        name: "MerchantConfiguration",
        params: {
          id: value
        }
      });
    },
  },
  mounted() {
    if (this.status) {
      this.$vs.notify({
        title: "Device",
        text: "Device success",
        color: "success",
        position: "top-right"
      });
    }
    this.gridApi = this.gridOptions.api;
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: '#f9f9f9' }
      }
    }
    this.gridOptions.rowHeight = 42;

    this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
      this.editRecord(data)
    });
    this.$root.$on("delete-from-ActionTableAgGridComponent", data => {
     this.deleteRecord(data)
    });
  }
};
</script>